// extracted by mini-css-extract-plugin
export default {"login":"Login_login__QdBJ0","container":"Login_container__XXB6O","logoContainer":"Login_logoContainer__Zw5uI","qrContainer":"Login_qrContainer__ROeCv","button":"Login_button__09vFX"};